import { useSelector } from 'react-redux';
import { GenericObject } from 'v2/models';
import { filterApprovedProposals, getKeyCount } from 'v2/utils/proposalUtils';

export default function useSelectApprovedProposals() {
  const selectApprovedProposals = useSelector((state: GenericObject) => {
    const approvedProposals = filterApprovedProposals(
      state.proposals.multipleProposals
    );
    return getKeyCount(approvedProposals);
  });

  return selectApprovedProposals;
}
